import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { MessageSquarePlus, Loader2 } from "lucide-react";

export const SuggestionForm = ({ personId, trigger }) => {
  const { API } = useAuth();
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !message.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/suggestions`, {
        person_id: personId || null,
        author_name: name,
        author_contact: contact,
        message,
      });
      toast.success(t("suggestionSent"));
      setOpen(false);
      setName(""); setContact(""); setMessage("");
    } catch (_) {
      toast.error("Error");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="outline" className="border-[#6B4226] text-[#6B4226]" data-testid="suggest-edit-btn">
            <MessageSquarePlus className="w-4 h-4 mr-2" /> {t("suggestEdit")}
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="bg-[#FAF7F2] max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-serif-heritage text-2xl text-[#261911]">{t("suggestEdit")}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#6E5B4F] mb-3">{t("suggestDesc")}</p>
        <form onSubmit={submit} className="space-y-3" data-testid="suggestion-form">
          <div>
            <Label>{t("yourName")} *</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="suggest-name-input" />
          </div>
          <div>
            <Label>{t("yourContact")}</Label>
            <Input value={contact} onChange={(e) => setContact(e.target.value)} placeholder="email / tel / whatsapp" data-testid="suggest-contact-input" />
          </div>
          <div>
            <Label>{t("yourMessage")} *</Label>
            <Textarea rows={5} value={message} onChange={(e) => setMessage(e.target.value)} required data-testid="suggest-message-input" />
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <Button type="button" variant="ghost" onClick={() => setOpen(false)}>{t("cancel")}</Button>
            <Button type="submit" className="btn-terra" disabled={loading} data-testid="suggest-submit-btn">
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
              {t("sendSuggestion")}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default SuggestionForm;
